import { useState, useEffect, forwardRef } from 'react';
import Axios from 'axios';
import {
    Paper, TableBody, makeStyles, TableCell, TableRow, Button, IconButton, Modal, Card, CardHeader, Divider,
    CardContent, Grid, TextField, Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle
} from '@material-ui/core';
import Cookies from 'universal-cookie';
import AdminTable from '../Components/AdminTable';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useHistory } from 'react-router';
import { Edit, Cancel } from '@mui/icons-material';
import './WriteupAdmin.css';
const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const categoryS = [
    {
        label: '',
        value: ''
    },
    {
        value: 1,
        label: 'Esteganografía'
    },
    {
        value: 2,
        label: 'Criptografía'
    },
    {
        value: 3,
        label: 'OSINT'
    },
    {
        value: 4,
        label: 'Pwn'
    },
    {
        value: 5,
        label: 'Explotación Web'
    },
    {
        value: 6,
        label: 'Fundamentos'
    },
    {
        value: 7,
        label: 'Ingeniería Inversa'
    },
    {
        value: 8,
        label: 'Programación'
    },
    {
        value: 9,
        label: 'Seguridad Móvil'
    },
    {
        value: 10,
        label: 'Misceláneo'
    },
    {
        value: 11,
        label: 'Análisis Forense'
    },

    {
        value: 12,
        label: 'Trivia'
    },

];

const WriteupAdmin = (props) => {
    const [title, setTitle] = useState([]);
    const [category, setCategory] = useState(0);
    const [link, setLink] = useState('');
    const [updateWriteup, setUpdateWriteup] = useState(false);
    const [openSuccess, setOpenSuccess] = useState(false);
    const [openError, setOpenError] = useState(false);
    const [error, setErrorMessage] = useState('');
    const [success, setSuccessMessage] = useState('');
    const [record, setRecord] = useState([]);
    const [modalEdit, setModalEdit] = useState(false);
    const [modalCreate, setModalCreate] = useState(false);
    const [deleteID, setDeleteID] = useState(0);
    const [modalWriteupID, setModalWriteupID] = useState(0);
    const [titleEdit, setTitleEdit] = useState([]);
    const [categoryEdit, setCategoryEdit] = useState(0);
    const [linkEdit, setLinkEdit] = useState('');
    const cookies = new Cookies();
    const userToken = cookies.get('tokenCTF');
    const [openRemoveDialog, setOpenRemoveDialog] = useState(false);
    const history = useHistory();
    const [records, setRecords] = useState([]);
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenError(false);
        setOpenSuccess(false);
    };
    const useStyles = makeStyles(theme => ({
        pageContent: {
            marginTop: '15vh',
            marginLeft: '30vw',
            width: '60%',
            padding: theme.spacing(3),
            overflowX: 'auto',
            overflowY: 'hidden',
            marginBottom: '20px'
        },
        card: {
            width: '80%',
            marginTop: '30px',
            marginLeft: '10%',
        },
        box: {
            display: 'flex',
            marginTop: theme.spacing(3),

        },
        boxButtonEdit: {
            display: 'flex',
            marginTop: theme.spacing(3),
            backgroundColor: '#8D002E',

        },
        boxButton: {
            display: 'flex',
            marginTop: theme.spacing(3),
            justifyContent: 'flex-end',

        },
        buttonLeft: {
            position: 'flex',
            backgroundColor: 'orange',
            right: '10%'

        },
        buttonRight: {
            marginBottom: '1%',
            marginRight: '2%',
            height: '50%',
            width: '15%',
            fontSize: '0.7em',
        },
        cardPosts: {
            width: '60%',
            marginTop: '30px',
            marginLeft: '20%',
            marginBottom: '30px'
        },
        cardHead: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        buttonModified: {
            position: 'flex',
            margin: theme.spacing(1),
        }, modalEdit: {
            position: 'absolute',
            width: '70vw',
            height: '45vh',
            backgroundColor: 'white',
            border: '2px solid #000',
            boxShadow: theme.shadows[5],
            //padding: '16px 32px 24px',
            padding: theme.spacing(2, 4, 3, 4),
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            overflow: 'auto',
        },
        cardEdit: {
            position: 'relative',
            width: '100%',

        }
    }))
    const styles = useStyles();

    const headCells = [
        { id: 'username', label: 'Usuario' },
        { id: 'title', label: 'Título' },
        { id: 'category', label: 'Categoría', disableSorting: true },
        { id: 'link', label: 'Link', disableSorting: true },
        { id: 'actions', label: 'Acciones', disableSorting: true },

    ]
    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = AdminTable(records, headCells);

    const openCloseModalCreate = () => {
        setModalCreate(!modalCreate);
        setTitle('');
        setCategory(0);
        setLink('');
    }
    const onSubmit = () => {
        Axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/writeups/postWriteup`, {
            title: title,
            category: category,
            link: link,
        }, {
            headers: { 'Authorization': userToken }
        }).then((res) => {
            if (res.data.noAuth) {
                cookies.remove('tokenCTF', { path: '/' });
                history.push('/login');
            }
            else {
                if (res.data.messageSuccess) {
                    setTitle('');
                    setCategory(0);
                    setLink('');
                    setSuccessMessage(res.data.messageSuccess);
                    setOpenSuccess(true);
                    setUpdateWriteup(true);
                    setModalCreate(false);
                }
                else if (res.data.messageError) {
                    setErrorMessage(res.data.messageError);
                    setOpenError(true);
                }
                else {
                    setErrorMessage('');
                    setOpenError(false);
                    setSuccessMessage('');
                    setOpenSuccess(false);
                }
            }
        });
    };
    const openModalEdit = (writeup_id) => {
        setModalWriteupID(writeup_id);
        Axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/writeups/getWriteupAdminInfo`, { writeup_id: writeup_id }, {
            headers: { 'Authorization': userToken }
        }).then(
            (response) => {
                if (response.data.noAuth) {
                    cookies.remove('tokenCTF', { path: '/' });
                    history.push('/login');
                }
                else {
                    setTitleEdit(response.data.writeup);
                    setCategoryEdit(response.data.category);
                    setLinkEdit(response.data.link);
                    setModalEdit(true);
                }
            })

    }
    const closeModalEdit = () => {
        setModalWriteupID(0);
        setModalEdit(false);
    }
    const onUpdate = (writeup_id) => {
        Axios.put(`https://${process.env.REACT_APP_BASE_URL}/api/writeups/updateAdminWriteup`, {
            writeup_id: writeup_id,
            title: titleEdit,
            category: categoryEdit,
            link: linkEdit
        }, {
            headers: { 'Authorization': userToken }
        }).then(res => {
            if (res.data.noAuth) {
                cookies.remove('tokenCTF', { path: '/' });
                history.push('/login');
            }
            else {
                if (res.data.messageSuccess) {
                    setSuccessMessage(res.data.messageSuccess);
                    setModalEdit(false);
                    setOpenSuccess(true);
                    setUpdateWriteup(true);

                }
                else if (res.data.messageError) {
                    setErrorMessage(res.data.messageError);
                    setOpenError(true);
                }
                else {
                    setSuccessMessage('')
                    setErrorMessage('')
                    setOpenError(false);
                    setOpenSuccess(false);
                }
            }
        });
    }
    const onDelete = (id) => {
        Axios.delete(`https://${process.env.REACT_APP_BASE_URL}/api/writeups/deleteAdminWriteup/${id}`, {
            headers: { 'Authorization': userToken }
        }).then((res) => {
            if (res.data.noAuth) {
                cookies.remove('tokenCTF', { path: '/' });
                history.push('/login');
            }
            else {
                if (res.data.messageSuccess) {
                    setSuccessMessage(res.data.messageSuccess);
                    setOpenSuccess(true);
                    setUpdateWriteup(true);
                    setOpenRemoveDialog(false);
                }
                else if (res.data.messageError) {
                    setErrorMessage(res.data.messageError);
                    setOpenError(true);
                }
                else {
                    setErrorMessage('');
                    setOpenError(false);
                    setSuccessMessage('');
                    setOpenSuccess(false);
                }
            }
        });

    }
    function handleOpenRemoveDialog(id) {
        setOpenRemoveDialog(true);
        setDeleteID(id);
    };
    const handleCloseRemoveDialog = () => {
        setOpenRemoveDialog(false);
        setDeleteID(0);
    };
    useEffect(() => {
        Axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/writeups/getWriteup`, {
            headers: { 'Authorization': userToken }
        }).then((response) => {
            if (response.data.noAuth) {
                cookies.remove('tokenCTF', { path: '/' });
                history.push('/login');
            }
            else if (response.data.noAdmin) {
                history.push('/user');
            }
            else {

                setRecords(response.data)
                setUpdateWriteup(false);

            }
        })
    }, [updateWriteup])
    return (
        <div className='writeupAdmin'>
            <Paper className="pageContent">
                <div align="right">
                    <Button onClick={(e) => openCloseModalCreate()} color='primary' variant='outlined'>Nueva publicación </Button>
                </div>
                <TblContainer>
                    <TblHead />
                    <TableBody>
                        {
                            recordsAfterPagingAndSorting().map(item => (
                                <TableRow key={item.writeup_id} >
                                    <TableCell>{item.username}</TableCell>
                                    <TableCell>{item.writeup}</TableCell>
                                    <TableCell>{item.category}</TableCell>
                                    <TableCell>{item.link}</TableCell>
                                    <TableCell>
                                        <IconButton onClick={(e) => openModalEdit(item.writeup_id)}>
                                            <Edit fontSize="small" color="primary" />
                                        </IconButton>
                                        <IconButton color="error" onClick={(e) => { handleOpenRemoveDialog(item.writeup_id) }}>
                                            <Cancel fontSize="small" color="error" />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))
                        }
                    </TableBody>
                </TblContainer>
                <TblPagination />
            </Paper>
            <Modal open={modalCreate} onClose={openCloseModalCreate} >
                <div className="modalEdit" >
                    <form
                        autoComplete="off"
                    >
                        <Card className="cardEdit">
                            <CardHeader
                                title="Crear Writeup"
                            />
                            <Divider />


                            <CardContent>
                                <Grid
                                    container
                                    spacing={3}
                                >
                                    <Grid
                                        item
                                        md={6}
                                        xs={12}
                                    >

                                        <TextField
                                            fullWidth
                                            label="Título"
                                            name="Titulo"
                                            value={title}
                                            variant="outlined"
                                            onChange={(e) => {
                                                setTitle(e.target.value)
                                            }}

                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        md={6}
                                        xs={12}
                                    >
                                        <TextField
                                            fullWidth
                                            label="Categoría"
                                            name="Category"
                                            required
                                            select
                                            SelectProps={{ native: true }}
                                            value={category}
                                            variant="outlined"
                                            onChange={(e) => {
                                                setCategory(e.target.value)
                                            }}
                                        >
                                            {categoryS.map((option, index) => (
                                                <option
                                                    key={index}
                                                    value={option.value}
                                                >
                                                    {option.label}
                                                </option>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid
                                        item
                                        md={6}
                                        xs={12}
                                    >
                                        <TextField
                                            fullWidth
                                            label="Link - ej. https://www.google.com"
                                            name="Link"
                                            value={link}

                                            variant="outlined"
                                            onChange={(e) => {
                                                setLink(e.target.value)
                                            }}
                                        />
                                    </Grid>


                                </Grid>
                            </CardContent>



                            <Divider />
                            <Box

                                className="boxButton"
                            >
                                <Button className="buttonRight"
                                    variant="outlined"
                                    color="primary"
                                    onClick={(e) => { onSubmit() }}
                                >
                                    Publicar
                                </Button>
                                <Button className="buttonRight"
                                    variant="outlined"
                                    color="secondary"
                                    onClick={(e) => { openCloseModalCreate() }}
                                >
                                    Cancelar
                                </Button>

                            </Box>

                        </Card>

                    </form>

                </div>
            </Modal>
            <Modal open={modalEdit} onClose={closeModalEdit}  >
                <div className="modalEdit">
                    <Card className="cardEdit">
                        <CardHeader
                            title="Editar Writeup"
                        />
                        <Divider />
                        <CardContent>
                            <Grid
                                container
                                spacing={3}
                            >
                                <Grid
                                    item
                                    md={6}
                                    xs={12}
                                >

                                    <TextField
                                        fullWidth
                                        label="Título"
                                        name="Titulo"
                                        value={titleEdit}
                                        variant="outlined"
                                        onChange={(e) => {
                                            setTitleEdit(e.target.value)
                                        }}

                                    />
                                </Grid>
                                <Grid
                                    item
                                    md={6}
                                    xs={12}
                                >
                                    <TextField
                                        fullWidth
                                        label="Categoría"
                                        name="Category"
                                        required
                                        select
                                        SelectProps={{ native: true }}
                                        value={categoryEdit}
                                        variant="outlined"
                                        onChange={(e) => {
                                            setCategoryEdit(e.target.value)
                                        }}
                                    >
                                        {categoryS.map((option, index) => (
                                            <option
                                                key={index}
                                                value={option.value}
                                            >
                                                {option.label}
                                            </option>
                                        ))}
                                    </TextField>
                                </Grid>
                                <Grid
                                    item
                                    md={6}
                                    xs={12}
                                >
                                    <TextField
                                        fullWidth
                                        label="Link"
                                        name="Link"
                                        value={linkEdit}

                                        variant="outlined"
                                        onChange={(e) => {
                                            setLinkEdit(e.target.value)
                                        }}

                                    />
                                </Grid>


                            </Grid>
                        </CardContent>



                        <Divider />
                        <Box

                            className="boxButton"
                        >
                            <Button className="buttonRight"
                                onClick={(e) => { onUpdate(modalWriteupID) }}
                                variant="outlined"
                                color="primary"
                            >
                                Actualizar
                            </Button>
                            <Button className="buttonRight"
                                variant="outlined"
                                color="secondary"
                                onClick={(e) => { closeModalEdit() }}
                            >
                                Cancelar
                            </Button>

                        </Box>

                    </Card>
                </div>
            </Modal>
            <Snackbar open={openError} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="error" className="alertWidthTop">
                    {error}
                </Alert>
            </Snackbar>
            <Snackbar open={openSuccess} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="success" className="alertWidthTop">
                    {success}
                </Alert>
            </Snackbar>
            <Dialog
                open={openRemoveDialog}
                onClose={handleCloseRemoveDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Eliminar Equipo"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        ¿Está seguro que desea eliminar el equipo?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={(e) => { onDelete(deleteID) }}>Sí</Button>
                    <Button onClick={handleCloseRemoveDialog} autoFocus>
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default WriteupAdmin;